import styled from "styled-components";

export const BoldSpan = styled("span")`
  font-weight: bold;
`;
BoldSpan.displayName = "BoldSpan";
